export const CURRENCY_SYMBOL = "NAD$";


export const APP_NAME = "Betwin";
